module.exports = __webpack_public_path__ + "assets/img/back-22d6f4a9.png";